const getters = {
    sidebar: state => state.app.sidebar,
    size: state => state.app.size,
    device: state => state.app.device,
    
    username: state => state.user.username,
    token: state => state.user.token,
  }
  export default getters
  